(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("debug", [], factory);
	else if(typeof exports === 'object')
		exports["debug"] = factory();
	else
		root["debug"] = factory();
})(self, function() {
return 